import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useRouter from '../../../hooks/useRouter';

CancelledBanner.propTypes = {
  event: PropTypes.object.isRequired
};

export default function CancelledBanner(props) {
  const { event, creator } = props;

  const launch = useDialogLauncher();
  const { history } = useRouter();

  function onDuplicate() {
    launch(DialogManager.EventDuplicate.Config(event.id));
  }

  function onFindPartners() {
    launch(DialogManager.EventManage.Config(event.id, '/invite-populate'));
  }

  return (
    <Wrapper
      color="gray"
      creator={creator}
      title={(
        <>
          Your event was cancelled.
        </>
      )}
      subtitle={(
        <>
          Event cancelled? That's okay! If you'd like to revisit this idea, simply
          duplicate it below to start again with your previous details.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={() => history.push('/view')}>
          View event
        </ConnectButton>
        <ConnectButton outline={true} onClick={onDuplicate}>
          Duplicate event
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
